module.exports = __webpack_public_path__ + "media/images/favicons/favicon-95e1dc4539b3df312b1e3aca54ec0ae9.ico";